var $5b2e5709864cc922$exports = {};
$5b2e5709864cc922$exports = {
  "dragDescriptionKeyboard": "Nospiediet Enter, lai s\u0101ktu vilk\u0161anu.",
  "dragDescriptionKeyboardAlt": "Nospiediet tausti\u0146u kombin\u0101ciju Alt+Enter, lai s\u0101ktu vilk\u0161anu.",
  "dragDescriptionLongPress": "Turiet nospiestu, lai s\u0101ktu vilk\u0161anu.",
  "dragDescriptionTouch": "Veiciet dubultsk\u0101rienu, lai s\u0101ktu vilk\u0161anu.",
  "dragDescriptionVirtual": "Noklik\u0161\u0137iniet, lai s\u0101ktu vilk\u0161anu.",
  "dragItem": function dragItem(args) {
    return "Velciet ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Velciet ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " atlas\u012Bto vienumu");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " atlas\u012Btos vienumus");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Nospiediet tausti\u0146u Enter, lai vilktu ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " atlas\u012Bto vienumu");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " atlas\u012Btos vienumus");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Nospiediet tausti\u0146u kombin\u0101ciju Alt+Enter, lai vilktu ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " atlas\u012Bto vienumu");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " atlas\u012Btos vienumus");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Turiet nospiestu, lai vilktu ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " atlas\u012Bto vienumu");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " atlas\u012Btos vienumus");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Uzs\u0101kta vilk\u0161ana. Nospiediet tausti\u0146u Tab, lai p\u0101rietu uz nome\u0161anas m\u0113r\u0137i, p\u0113c tam nospiediet Enter, lai nomestu, vai nospiediet Escape, lai atceltu.",
  "dragStartedTouch": "Uzs\u0101kta vilk\u0161ana. P\u0101rejiet uz nome\u0161anas m\u0113r\u0137i, p\u0113c tam veiciet dubultsk\u0101rienu, lai nomestu.",
  "dragStartedVirtual": "Uzs\u0101kta vilk\u0161ana. P\u0101rejiet uz nome\u0161anas m\u0113r\u0137i, p\u0113c tam nospiediet Enter, lai nomestu.",
  "dropCanceled": "Nome\u0161ana atcelta.",
  "dropComplete": "Nome\u0161ana pabeigta.",
  "dropDescriptionKeyboard": "Nospiediet Enter, lai nomestu. Nospiediet Escape, lai atceltu vilk\u0161anu.",
  "dropDescriptionTouch": "Veiciet dubultsk\u0101rienu, lai nomestu.",
  "dropDescriptionVirtual": "Noklik\u0161\u0137iniet, lai nomestu.",
  "dropIndicator": "nome\u0161anas indikators",
  "dropOnItem": function dropOnItem(args) {
    return "Nometiet uz ".concat(args.itemText);
  },
  "dropOnRoot": "Nometiet uz",
  "endDragKeyboard": "Notiek vilk\u0161ana. Nospiediet Enter, lai atceltu vilk\u0161anu.",
  "endDragTouch": "Notiek vilk\u0161ana. Veiciet dubultsk\u0101rienu, lai atceltu vilk\u0161anu.",
  "endDragVirtual": "Notiek vilk\u0161ana. Noklik\u0161\u0137iniet, lai atceltu vilk\u0161anu.",
  "insertAfter": function insertAfter(args) {
    return "Ievietojiet p\u0113c ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Ievietojiet pirms ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Ievietojiet starp ".concat(args.beforeItemText, " un ").concat(args.afterItemText);
  }
};
export { $5b2e5709864cc922$exports as default };